/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import { NvMatTooltipComponent } from './nv-mat-tooltip.component';
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER, NvMatTooltip } from './nv-mat-tooltip.directive';

@NgModule({
  imports: [CommonModule, OverlayModule, MatCommonModule, A11yModule],
  exports: [NvMatTooltip, NvMatTooltipComponent, MatCommonModule],
  declarations: [NvMatTooltip, NvMatTooltipComponent],
  entryComponents: [NvMatTooltipComponent],
  providers: [MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class NvMatTooltipModule {}
